<template>
	<div>
		<div class="cont">
			<Breadcrumb :pathList='pathList'></Breadcrumb>
			<div class="flex">
				<div class="search flex">
					<img src="../../assets/icon/search.png" style="width: 16px;height: 16px;" alt="" />
					<input class="flex-1" type="text" v-model="keyword" placeholder="输入关键词搜索相关问题" @keyup.enter="searchQuestion(keyword)">
				</div>
				<div class="flex-1"></div>
			</div>
			<div class="flex">
				<div class="searchItem pointer" v-for="(item,index) in list" @click="searchQuestion(item)">{{item}}</div>
			</div>
			<div class="result">共找到 <span>{{questionList.length}}</span> 个内容</div>
			<el-collapse accordion>
				<el-collapse-item :title="item.problem" v-for="(item,index) in questionList">
					<div>{{item.answer}}</div>
				</el-collapse-item>
			</el-collapse>
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getQuestion
	} from "@/api/common";
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import toTop from '../../components/toTop.vue'
	import Footer from '../../components/Footer.vue'
	export default {
		data() {
			return {
				pathList: [{
						title: '我的',
						path: '/mine'
					},
					{
						title: '常见问题',
						path: ''
					}
				],
				keyword:'',
				questionList:[],
				list:['课程','培训','会员','积分']
			}
		},
		components: {
			Breadcrumb,
			toTop,
			Footer
		},
		mounted() {
			this.getQuestionList()
		},
		methods: {
			searchQuestion(e){
				if(e){
					this.keyword=e
				}
				this.getQuestionList()
			},
			async getQuestionList() {
				const {
					status,
					data
				} = await getQuestion({
					keyword:this.keyword
				});
				this.questionList=data.result
			},
			handleChange(val) {
				console.log(val);
			}
		}
	}
</script>

<style lang="less" scoped>
	.cont {
		padding: 30px 133px 0;
		min-height: 60vh;
		.search {
			margin-top: 30px;
			width: 30%;
			height: 40px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			input {
				margin-left: 10px;
				border: none;
				background-color: transparent;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333;

				&:focus {
					outline: none;
				}
			}
		}

		.searchItem {
			margin: 10px 10px 0 0;
			height: 31px;
			padding: 0 8px;
			background: #fff;
			border-radius: 9px 9px 9px 9px;
			border: 1px solid #EEEEEE;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
			line-height: 31px;
		}

		.result {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #000000;
			line-height: 60px;

			span {
				color: #00A73C;
			}
		}
	}

	::v-deep .el-collapse {
		border: none;

		.el-collapse-item__wrap {
			border-bottom: none;
		}
	}

	::v-deep .el-collapse-item {
		margin-bottom: 20px;
		background: #FFFFFF;
		box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
		border-radius: 13px 13px 13px 13px;
		padding: 6px 20px;

		.el-collapse-item__header {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #000000;
			border-bottom: none;
		}

		.el-collapse-item__content {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
			line-height: 22px;
		}
	}
</style>